import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import ApiSupplier from "../../../core/api/api.supplier";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import SwalMessage from "../_Components/SwalMessage";
import { Row, Col, Button, Modal, Accordion, Spinner } from "react-bootstrap";
import TextField from "@mui/material/TextField";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { PatternFormat } from "react-number-format";
import { useEffect } from "react";
import _ from "lodash";
import { tools } from "../../../core/utils/tools";
import Swal from "sweetalert2";
import { DateObject } from "react-multi-date-picker";
import { persian, customLocale } from "../_Components/customLocale";
import Select from "react-select";
import CloseIcon from "@mui/icons-material/CloseRounded";
import LogoutIcon from "@mui/icons-material/Logout";
import Delete from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import HTMLInput from "../_Components/HTMLInput";

//وقتی که فقط یک بلیط انتخاب شود وارد این مدال میشه
//ویرایش تراکنش تامین کننده برای بلیط هایی که بیشتر از یک پرداخت/دریافت به تامین کننده دارند-حذف تراکنش تامین کننده
function EditPayToWarrantyModal({ typeOfModalWaranty, selectedItem, basketId, setShowModalEditWarranty }) {
  const {
    handleSubmit,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm();
  const customStyles = {
    menuPortal: (base) => ({
      ...base,
      zIndex: 1000000, // اطمینان از اینکه منو در بالای سایر المان‌ها قرار گیرد
    }),
    menu: (base) => ({
      ...base,
      position: "absolute", // منو در موقعیت ثابت قرار می‌گیرد
    }),
    // control: (provided, state) => ({
    //   ...provided,
    //   borderColor: state.isFocused ? "#19caac" : state.isHovered ? "#19caac" : "gray", // رنگ حاشیه زمانی که فوکوس شده
    //   borderWidth: state.isFocused ? "2px" : state.isHovered ? "2px" : "1px", // اندازه حاشیه زمانی که فوکوس شده

    //   boxShadow: state.isFocused ? " " : " ", // سایه برای فوکوس
    // }),
  };
  let showPrice = new Intl.NumberFormat("en-US");
  const [ordersServiceGetItem, setOrderServiceGetItem] = useState(null);
  const [submitAndExit, setsubmitAndExit] = useState(false);
  const [isDeleteButton, setIsDeleteButton] = useState(false);
  const [supplier, setSupplier] = useState([]);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const handleRadioChange = (transactionId) => {
    setSelectedTransactionId(transactionId);
  };

  useEffect(() => {
    (async () => {
      try {
        // صبر کنید تا supplier مقداردهی شود
        if (ordersServiceGetItem === null) {
          await fetchModalItemsContent();
        } else if (ordersServiceGetItem?.succeeded) {
          ordersServiceGetItem?.data.map((item) => {
            item.basketItemPersonList?.map((person) => {
              const transactions = person.transactions.filter(
                (t) =>
                  t.isDeleted === false &&
                  (typeOfModalWaranty === "editReceiveFromWarranty" ? t.type === 4 : t.type === 3),
              );
              if (transactions.length === 1) {
                const firstTransactionId = transactions[0]?.id;
                handleRadioChange(firstTransactionId);
              }
            });
          });
        }
      } catch (error) {
      }
    })();
  }, [ordersServiceGetItem]);

  const handleClose = () => {
    setShowModalEditWarranty(false);
  };

  const onSubmit = async (data) => {
    if (!selectedTransactionId) {
      SwalMessage({
        title: "هیچ تراکنشی انتخاب نشده است.",
        iSsuccess: false,
      });
      return;
    }

    let basketItemPersons = [];
    let jsonData = {};
    for (const item of ordersServiceGetItem.data) {
      for (const person of item.basketItemPersonList) {
        const transaction = person.transactions.find((t) => t.id === selectedTransactionId);
        const date = data[`date_${selectedTransactionId}`];
        if (date !== null && typeof date === "object") {
          data[`date_${selectedTransactionId}`] = tools.DateFormat(date);
        }
        if (transaction) {
          basketItemPersons.push({
            basketItemPersonId: person.id,
            basketId: person.basketId,
            transactionId: selectedTransactionId,
          });
          jsonData = {
            basketItemPersonId: person.id,
            basketId: person.basketId,
            transactionId: selectedTransactionId,
            amount: parseFloat(data[`price_${selectedTransactionId}`].replaceAll(",", "")),
            date: data[`date_${selectedTransactionId}`], // تاریخ
            time: data[`time_${selectedTransactionId}`], // زمان
            description: data[`description_${selectedTransactionId}`],
            supplierId: data[`supplierId_${selectedTransactionId}`]?.value,
            warrantyPaymentType: typeOfModalWaranty == "editPayToWarranty" ? 1 : 2,
          };
        }
        break;
      }
    }

    try {
      if (isDeleteButton) {
        Swal.fire({
          title: `عملیات حذف پرداخت/دریافت تامین کننده شماره ${selectedTransactionId}`,
          text: `پرداخت/دریافت تامین کننده شماره ${selectedTransactionId} حذف خواهد شد، اطمینان دارید؟`,
          icon: "question",
          showDenyButton: true,
          confirmButtonText: "بله",
          denyButtonText: "خیر",
          customClass: {
            actions: "my-actions",
            cancelButton: "order-1 right-gap btn btn-secondary ",
            confirmButton: "order-2 btn btn-success px-5",
            denyButton: "order-3 btn btn-danger px-5",
          },
          focusCancel: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            const response = await ApiBasketItemPerson.DeletePayOrReceiveWarranty({
              basketItemPersons: basketItemPersons,
              warrantyPaymentType: typeOfModalWaranty == "editPayToWarranty" ? 1 : 2,
            });
            if (response.succeeded) {
              SwalMessage({
                title: "با موفقیت حذف شد.",
                iSsuccess: true,
              });
              handleClose();
              document.getElementById("submitButton").click();
            } else
              SwalMessage({
                title: response.message,
                iSsuccess: false,
              });
          }
        });
      } else {
        const ReceiveFromWaranty = await ApiBasketItemPerson.EditPayOrReceiveWarranty(jsonData);
        if (ReceiveFromWaranty.succeeded) {
          if (submitAndExit) {
            handleClose();
          }
          SwalMessage({
            title: "تغییرات با موفقیت اعمال شد",
            iSsuccess: true,
          });
          await fetchModalItemsContent();
          document.getElementById("submitButton").click();
        } else
          SwalMessage({
            title: ReceiveFromWaranty.message,
            iSsuccess: false,
          });
      }
    } catch (error) {
    }
  };

  async function fetchModalItemsContent() {
    const allSupplier = await ApiSupplier.getAllSuppliersName();
    setSupplier(allSupplier);
    let selectedItemSTR = "";
    selectedItem.forEach((item) => {
      selectedItemSTR += "ListBasketItemPersonID=" + item + "&";
    });
    if (typeOfModalWaranty === "payToWarranty" || typeOfModalWaranty === "receiveFromWaranty") {
      const ordersServiceGetItem = await ApiBasketItemPerson.GetItemForWaranty({
        listBasketItemPersonID: selectedItemSTR,
      });
      setOrderServiceGetItem(ordersServiceGetItem);
      if (!_.isEmpty(ordersServiceGetItem.data)) {
        ordersServiceGetItem.data.map((item) => {
          const { shamsiDate, time } = setDefaultDateAndTime();
          setValue("date_" + item.id, shamsiDate);
          setValue("time_" + item.id, time);
        });
      }
    } else if (typeOfModalWaranty === "editPayToWarranty" || typeOfModalWaranty === "editReceiveFromWarranty") {
      var warrantyPaymentType = typeOfModalWaranty === "editPayToWarranty" ? 1 : 2;
      // const basketItemPersons = await ApiBasketItemPerson.GetItemForEditWarranty({
      //   queryString: `${selectedItemSTR}&warrantyPaymentType=${warrantyPaymentType}`,
      // });
      const basketItemPersons = await ApiBasketItemPerson.GetItemForEditWarranty({
        basketItemPersonList: selectedItem,
        warrantyPaymentType: warrantyPaymentType, // مقدار عددی
      });
      setOrderServiceGetItem(basketItemPersons);
      if (!_.isEmpty(basketItemPersons.data)) {
        basketItemPersons.data?.forEach((person) => {
          person?.basketItemPersonList.forEach((person2) => {
            person2.transactions.forEach((item) => {
              const { shamsiDate, time } = setDefaultDateAndTime();
              setValue("date_" + item.id, item.completionDate ? item.completionDate : shamsiDate);
              setValue("time_" + item.id, item.completionTime ? item.completionTime : time);
              setValue("description_" + item.id, item.description);
              setValue("price_" + item.id, String(item.price));
              const companyName = allSupplier.find((i) => i.id === item.supplierId)?.companyName;
              const defaultValueForSelectComponent = { value: item.supplierId, label: companyName };
              setValue("supplierId_" + item.id, defaultValueForSelectComponent);
            });
          });
        });
      }
    }
  }

  const setDefaultDateAndTime = () => {
    const date = new Date();
    const shamsiDate = new DateObject({ calendar: persian, locale: customLocale });
    const hour = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    const time = `${hour}:${minutes}`; // ##:## format
    return { shamsiDate, time };
  };

  const inputChangeHandler = (event, onChange, type, transactionId, person) => {
    if (["percent_", "price_"].includes(type)) {
      if (type == "price_") {
        const priceValue = +event.target.value?.replace(",", "");
        const percentage = ((priceValue / person.originalPrice) * 100).toFixed(1);
        setValue("percent_" + transactionId, percentage);
      } else {
        const value = Number(event.target.value);
        if (value > 100 || value < 0) return;
        const percentage = value / 100;
        const price = showPrice.format(person.originalPrice * percentage);
        setValue("price_" + transactionId, price);
      }
    }

    type == "price_"
      ? setValue("price_" + transactionId, showPrice.format(Number(event.target.value.replaceAll(",", ""))))
      : onChange(event);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          {ordersServiceGetItem && ordersServiceGetItem.succeeded ? (
            ordersServiceGetItem?.data?.map((item, index) => (
              <div className="pt-5 mt-5" key={index}>
                <div className="p-3 rounded position-relative" style={{ border: "3px solid rgb(162, 166, 185)" }}>
                  <div className="pt-3 div-scroll-box">
                    <h5 className="px-4 text-bold position-absolute bg-white" style={{ top: "-13px" }}>
                      {item.hallEventTitle ? `${item?.basketItemAmusementServiceName} - ${item.hallEventTitle}` : `${item?.basketItemAmusementServiceName} - ${item?.basketItemAmusementServiceReserveItemGroupTitle} - ${item?.basketItemAmusementServiceReserveItemTitle}`}
                    </h5>
                    {item.basketItemPersonList?.map((person, personIndex) =>
                      person.transactions
                        .filter(
                          (t) =>
                            t.isDeleted === false &&
                            (typeOfModalWaranty === "editReceiveFromWarranty" ? t.type === 4 : t.type === 3),
                        )
                        .map((transaction, transactionIndex) => {
                          return (
                            <div className="mb-5" key={transaction.id}>
                              <Accordion>
                                <Row className={`mt-2 min-width-row ${window.innerWidth > 991 && "flex-nowrap"}`}>
                                  <Col xs="12" lg="auto">
                                    <input
                                      type="radio"
                                      name="selectTransaction"
                                      checked={selectedTransactionId === transaction.id}
                                      onChange={() => handleRadioChange(transaction.id)}
                                    />
                                  </Col>
                                  <Col xs="12" sm="4" lg="auto" className="mb-5 mb-lg-0 px-lg-1">
                                    <div className="floating-label-content">
                                      <input
                                        type="text"
                                        className={`floating-input form-control width-input-medium `}
                                        placeholder=""
                                        value={person.basketId}
                                        disabled
                                      />
                                      <label className="floating-label text-secondary">شماره سفارش</label>
                                    </div>
                                  </Col>
                                  <Col xs="12" sm="4" lg="auto" className="mb-5 mb-lg-0 px-lg-1">
                                    <div className="floating-label-content">
                                      <input
                                        type="text"
                                        className={`floating-input form-control width-input-medium `}
                                        placeholder=""
                                        value={person.id}
                                        disabled
                                      />
                                      <label className="floating-label text-secondary">شماره بلیط</label>
                                    </div>
                                  </Col>
                                  <Col xs="12" md="3" className="mb-5 px-lg-1 mb-lg-0" style={{ maxWidth: 280 }}>
                                    <TextField
                                      disabled
                                      fullWidth
                                      variant="outlined"
                                      label={person.hallBlockName ? "صندلی" : "نام و نام خانوادگی"}
                                      value={person.hallBlockName ? `جایگاه: ${person.hallBlockName} - ردیف: ${person.hallRowName} - صندلی: ${person.hallSeatName}` : person.personFullName}
                                    />
                                  </Col>
                                  <Col xs="12" sm="4" lg="auto" style={{ width: 110 }} className="mb-5 mb-lg-0 px-lg-1">
                                    <div className="floating-label-content">
                                      <input
                                        type="text"
                                        className={`floating-input form-control`}
                                        placeholder=""
                                        value={`${showPrice.format(
                                          person.payToWarantyAmount - person.receiveOfWarantyAmount,
                                        )}`}
                                        disabled
                                      />
                                      <label className="floating-label text-secondary">پرداخت تامین کننده</label>
                                    </div>
                                  </Col>
                                  <Col xs="12" sm="4" lg="auto" className="mb-5 mb-lg-0 px-lg-1">
                                    <div className="floating-label-content">
                                      <input
                                        type="text"
                                        className={`floating-input form-control width-input-medium `}
                                        placeholder=""
                                        value={`${showPrice.format(person.paymentAmount)}`}
                                        disabled
                                      />
                                      <label className="floating-label text-secondary">مبلغ پرداختی</label>
                                    </div>
                                  </Col>
                                  <Col xs="12" sm="4" lg="auto" className="mb-5 px-lg-1 mb-lg-0">
                                    <div className="floating-label-content">
                                      <input
                                        type="text"
                                        className={`floating-input form-control width-input-medium`}
                                        placeholder=""
                                        value={`${showPrice.format(person.originalPrice)}`}
                                        disabled
                                      />
                                      <label className="floating-label text-secondary">نرخ مصوب </label>
                                    </div>
                                  </Col>
                                  <Col xs="12" sm="4" lg="2" className="mb-5 mb-lg-0 px-lg-1">
                                    <Controller
                                      name={`supplierId_${transaction.id}`}
                                      control={control}
                                      render={({ field: { onChange, value } }) => (
                                        <div className="floating-label-content">
                                          <Select
                                            styles={customStyles}
                                            placeholder=""
                                            options={supplier?.map((item) => ({
                                              value: item.id,
                                              label: item.companyName,
                                            }))}
                                            value={value || ""}
                                            onChange={onChange}
                                            isDisabled={selectedTransactionId !== transaction.id}
                                            menuPortalTarget={document.body}
                                            className="floating-input custom-style-select"
                                          />
                                          <label className="floating-label">تامین کننده</label>
                                        </div>
                                      )}
                                    />
                                  </Col>
                                  <Col xs="12" sm="4" lg="auto" className="mb-5 mb-lg-0 px-lg-1">
                                    <Controller
                                      name={`percent_${transaction.id}`}
                                      control={control}
                                      render={({ field: { onChange, value } }) => (
                                        <HTMLInput
                                          className={`form-control form-control width-input-small`}
                                          placeholder="درصد"
                                          value={value || ""}
                                          onInput={(e) => {
                                            // فقط اعداد مثبت و صفر مجاز باشه
                                            e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                          }}
                                          onChange={(event) =>
                                            inputChangeHandler(event, onChange, "percent_", transaction.id, person)
                                          }
                                          disabled={selectedTransactionId !== transaction.id}
                                          label="درصد"
                                        />
                                      )}
                                    />
                                  </Col>
                                  <Col xs="12" sm="4" lg="auto" className="mb-5 mb-lg-0 px-lg-1">
                                    <Controller
                                      name={`price_${transaction.id}`}
                                      control={control}
                                      rules={{ required: true }}
                                      render={({ field: { onChange, value } }) => (
                                        <HTMLInput
                                          className={`form-control ${errors[`price_${transaction.id}`] ? "border border-danger" : ""}`}
                                          placeholder="مبلغ"
                                          value={value || ""}
                                          onInput={(e) => {
                                            // فقط اعداد مثبت و صفر مجاز باشه
                                            e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                          }}
                                          onChange={(event) =>
                                            inputChangeHandler(event, onChange, "price_", transaction.id, person)
                                          }
                                          disabled={selectedTransactionId !== transaction.id}
                                          label="مبلغ"
                                        />
                                      )}
                                    />
                                  </Col>

                                  <Col
                                    xs="12"
                                    sm="4"
                                    lg="auto"
                                    className="mb-5 mb-lg-0 px-lg-1"
                                    style={{ position: "static" }}
                                  >
                                    <Controller
                                      name={`date_${transaction.id}`}
                                      control={control}
                                      style={{ zIndex: "999" }}
                                      render={({ field: { onChange, value } }) => (
                                        <ShamsiDatePicker
                                          value={value}
                                          onChange={(event) =>
                                            inputChangeHandler(event, onChange, "date_", transaction.id, personIndex)
                                          }
                                          placeholder="تاریخ"
                                          style={{ zIndex: "999" }}
                                          disabled={selectedTransactionId !== transaction.id}
                                        />
                                      )}
                                    />
                                  </Col>

                                  <Col xs="12" sm="4" lg="auto" className="mb-5 mb-lg-0 px-lg-1">
                                    <Controller
                                      name={`time_${transaction.id}`}
                                      rules={{ required: true }}
                                      control={control}
                                      disabled={selectedTransactionId !== transaction.id}
                                      render={({ field: { onChange, value } }) => (
                                        <PatternFormat
                                          label="ساعت"
                                          customInput={TextField}
                                          format="##:##"
                                          type="search"
                                          onKeyDown={(e) => {
                                            if (e.key === "Escape") {
                                              e.stopPropagation()
                                            }
                                          }}
                                          value={value || ""}
                                          onChange={(event) =>
                                            inputChangeHandler(event, onChange, "time_", transaction.id, personIndex)
                                          }
                                          placeholder="00:00"
                                          className={
                                            errors["time_" + transaction.id]
                                              ? "border border-danger form-control text-center"
                                              : "form-control text-center"
                                          }
                                          disabled={selectedTransactionId !== transaction.id}
                                          sx={{
                                            ".css-1ndlvje-MuiInputBase-root-MuiOutlinedInput-root": { padding: 0 },
                                          }}
                                        />
                                      )}
                                    />
                                  </Col>
                                  <Col xs="12" sm="4" lg="auto" className="mb-5 mb-lg-0 px-lg-1">
                                    <Controller
                                      name={`description_${transaction.id}`}
                                      control={control}
                                      render={({ field: { onChange, value } }) => (
                                        <div className="floating-label-content postion-relative">
                                          <textarea
                                            placeholder=""
                                            style={{ height: "43px" }}
                                            value={value || ""}
                                            className={`floating-input form-control min-width-textarea`}
                                            onChange={(event) => {
                                              inputChangeHandler(
                                                event,
                                                onChange,
                                                "description_",
                                                transaction.id,
                                                personIndex,
                                              );
                                            }}
                                            onKeyDown={(e) => {
                                              if (e.key === "Escape") {
                                                const input = e.target;
                                                if (input?.disabled) return
                                                if (input) input.value = null;
                                                const ev = new Event("input", { bubbles: true });
                                                input.dispatchEvent(ev);
                                                e.stopPropagation()
                                              }
                                            }}
                                            disabled={selectedTransactionId !== transaction.id}
                                          />
                                          <label className="floating-label text-secondary ">توضیحات</label>
                                          <IconButton
                                            type="button"
                                            style={{
                                              left: 25
                                            }}
                                            className="position-absolute top-50 translate-middle w-auto"
                                            onClick={(e) => {
                                              const input = e.currentTarget.closest(".floating-label-content").querySelector("textarea");
                                              if (input?.disabled || input?.readOnly) return
                                              if (input) input.value = null;
                                              const ev = new Event("input", { bubbles: true });
                                              input.dispatchEvent(ev);
                                            }}
                                            size="small"
                                          >
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        </div>
                                      )}
                                    />
                                  </Col>
                                </Row>
                              </Accordion>
                            </div>
                          );
                        }),
                    )}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-large">{ordersServiceGetItem && ordersServiceGetItem.message}</p>
          )}
        </Modal.Body>
        <Modal.Footer className="px-2 mx-0">
          {ordersServiceGetItem && ordersServiceGetItem.succeeded && (
            <div>
              <Button
                variant="success"
                className="btn btn-success ml-3"
                type="submit"
                onClick={() => {
                  setIsDeleteButton(false);
                  setsubmitAndExit(true);
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <LogoutIcon className="mr-1 " />
                ثبت و خروج
              </Button>

              <Button
                variant="danger"
                type="submit"
                disabled={isSubmitting}
                className="btn btn-success ml-3"
                onClick={() => {
                  setIsDeleteButton(true);
                }}
              >
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <Delete className="mr-1" />
                حذف
              </Button>
            </div>
          )}

          <Button variant="danger" onClick={handleClose}>
            <CloseIcon className="mr-1" />
            بستن
          </Button>
        </Modal.Footer>
      </form>
    </div>
  );
}
export default EditPayToWarrantyModal;
